import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import { trackPageView } from "./utils/analytics";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL, // <-- use dynamic base for correct routing
  routes: [
    {
      path: "/",
      name: "home",
      meta: { announcer: "Dashboard " },
      component: () => import("./views/Dashboard.vue"),
    },
    {
      path: "/auth",
      name: "auth",
      meta: { announcer: "Login" },
      component: () => import("./views/Auth.vue"),
    },
    {
      path: "/symptom/:module",
      name: "symptom",
      meta: { announcer: "Page" },
      component: () => import("./views/Symptom.vue"),
    },
    {
      path: "/behavior/:module",
      name: "behavior",
      meta: { announcer: "Page" },
      component: () => import("./views/Behavior.vue"),
    },
    {
      path: "/worksheets",
      name: "worksheets",
      meta: { announcer: "Page" },
      component: () => import("./views/Worksheets.vue"),
    },
    {
      path: "/steps",
      name: "steps",
      meta: { announcer: "Steps" },
      component: () => import("./views/Steps.vue"),
    },
  ],
});

// Update page title on route change
// The store plugin will automatically update document.title when changePageTitle is committed
router.beforeEach((to, from, next) => {
  // Update title based on route
  if (to.name === 'symptom' && to.params.module) {
    store.commit('changePageTitle', to.params.module);
    store.commit('changePageIntroText', '');
  } else if (to.name === 'behavior' && to.params.module) {
    store.commit('changePageTitle', to.params.module);
    store.commit('changePageIntroText', '');
  } else if (to.name === 'home') {
    store.commit('changePageTitle', 'Welcome');
    store.commit('changePageIntroText', '');
  } else if (to.name === 'steps') {
    store.commit('changePageTitle', 'steps');
    store.commit('changePageIntroText', '');
  } else if (to.name === 'worksheets') {
    store.commit('changePageTitle', 'Self-care Worksheets');
    store.commit('changePageIntroText', '');
  } else if (to.name === 'auth') {
    store.commit('changePageTitle', 'Login');
    store.commit('changePageIntroText', '');
  }
  
  next();
});

// Track page views on route change (Requirement ID: 5)
router.afterEach((to) => {
  const userId = store.getters.getUID;
  if (userId && to.name !== 'auth') {
    // Use the actual page title from store instead of route name
    // This gives us "Cognitive Function", "Pain", etc. instead of just "symptom"
    const pageTitle = store.getters.getPageTitle || to.name;
    trackPageView(pageTitle, to.path, userId);
  }
});

export default router;
